import { Button, Flex, Input, Modal } from "@mantine/core";
import { IconDeviceFloppy, IconX } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { usePostApi } from "src/hooks";
import { useDispatch, useSelector } from "src/redux/hooks";
import { setCurrentMeta } from "src/redux/slices/generatorSlice";
import { getYachtId } from "src/utils";
import { Notification } from "src/utils/Notification";

interface ISetLang {
  opened: boolean;
  close: () => void;
}

const SetLang = ({ opened, close }: ISetLang) => {
  const meta = useSelector(state => state.generatorSlice.meta);
  const dispatch = useDispatch();

  useEffect(() => {
    setMetaInput(meta.currentMetaValue);
  }, [meta]);

  const [metaInput, setMetaInput] = useState(meta.currentMetaValue);
  const { post, isLoading } = usePostApi();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMetaInput(e.target.value);
  };

  const handleSave = async () => {
    dispatch(
      setCurrentMeta({
        currentMetaValue: metaInput,
        currentMeta: meta.currentMeta,
      }),
    );
    await post({
      request: "save-meta",
      body: {
        params: {
          meta: { language: metaInput },
          metatype: meta.currentMeta,
          yacht: getYachtId(),
        },
      },
      onSuccess: () => {
        Notification("Success", "Meta language have been changed", "green");
        close();
      },
    });
  };

  return (
    <Modal
      opened={opened}
      onClose={close}
      title="Set Language"
      yOffset={"25dvh"}>
      <Input value={metaInput} onChange={handleChange} />

      <Flex mt={15} justify={"end"} w={"100%"}>
        <Button
          size="xs"
          leftSection={<IconX size={"1rem"} />}
          mr={5}
          color="red"
          onClick={close}>
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          loading={isLoading}
          size="xs"
          leftSection={<IconDeviceFloppy size={"1rem"} />}
          ml={5}>
          Save
        </Button>
      </Flex>
    </Modal>
  );
};

export default SetLang;
